/* Phone World 96: scroll reveal + ajax add-to-cart for custom sections */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.pw-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    els.forEach(function (el) { io.observe(el); });
  }

  var toast;
  function showToast(msg, ok) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'pw-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span></span>' + (ok ? '<a href="' + root + 'cart">View cart</a>' : '');
    toast.firstChild.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 4200);
  }

  function updateCartCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', cart.item_count === 0); });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-pw-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.innerHTML : '';
    var items = [];
    form.querySelectorAll('input[name="items[][id]"], input[name="id"]').forEach(function (inp) { items.push({ id: Number(inp.value), quantity: 1 }); });
    if (!items.length) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        showToast(items.length > 1 ? 'Items added to your cart' : 'Added to your cart', true);
        updateCartCount();
        if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1800); }
      })
      .catch(function (err) {
        showToast(err.message, false);
        if (btn) { btn.innerHTML = label; btn.disabled = false; }
      });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  else initReveal();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
